// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__+iehd","Hero":"Home_Hero__7-DsZ","Text":"Home_Text__yP2N6","About":"Home_About__yEUOM","Contact":"Home_Contact__YwYrv","Gallery":"Home_Gallery__9pYtc"};